import Vue from 'vue'
import Router from 'vue-router'
import header from '@/components/common/header'
import headerBack from '@/components/common/headBack'
import headloginHeader from '@/components/login/loginHeader.vue'
import homeHead from '@/components/home/header'
import home from '@/components/home'
import reportData from '@/components/reportData'
import memberAward from '@/components/memberAward'
import member from '@/components/member'
import club from '@/components/club'
import memberWarn from '@/components/memberWarn'
import toggle from '@/components/toggle'
import addMember from '@/components/addMember'
import userInfo from '@/components/userInfo'
import managerFind from '@/components/managerFind'
import login from '@/components/login'
import delClub from '@/components/delClub'
import awardProgress from '@/components/awardProgress'
import memberApply from '@/components/memberApply'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: '/home',
      component: () => import('@/components/home')
    },
    {
      path: '/home',
      name: 'home',
      components: {
        default: () => import('@/components/home'),
        header: homeHead
      },
      meta: {
        title: '首页'
      },
      children: []
    },
    {
      path: '/reportData',
      name: 'reportData',
      components: {
        default: () => import('@/components/reportData'),
        header: headerBack
      },
      meta: {
        title: '报表数据'
      }
    },
    {
      path: '/moneyDetail',
      name: 'moneyDetail',
      components: {
        default: () => import('@/components/reportData/moneyDetail'),
        header: headerBack
      },
      meta: {
        title: '钻石提成金额明细'
      },
    },
    {
      path: '/goldDetail',
      name: 'goldDetail',
      components: {
        default: () => import('@/components/reportData/goldDetail'),
        header: headerBack
      },
      meta: {
        title: '元宝提成金额明细'
      },
    },
    {
      path: '/changciDetail',
      name: 'changciDetail',
      components: {
        default: () => import('@/components/reportData/changciDetail'),
        header: headerBack
      },
      meta: {
        title: '场次历史数据'
      },
    },
    {
      path: '/memberAward',
      name: 'memberAward',
      components: {
        default: () => import('@/components/memberAward'),
        header: headerBack
      },
      meta: {
        title: '代理奖励'
      }
    },

    {
      path: '/member',
      name: 'member',
      components: {
        default: () => import('@/components/member'),
        header: headerBack
      },
      meta: {
        title: '我的代理'
      }
    },
    {
      path: '/addMember',
      name: 'addMember',
      components: {
        default: () => import('@/components/addMember'),
        header: headerBack
      },
      meta: {
        title: '授权代理'
      }
    },
    {
      path: '/managerFind',
      name: 'managerFind',
      components: {
        default: () => import('@/components/managerFind'),
        header: headerBack
      },
      meta: {
        title: '商务查询'
      }
    },
    {
      path: '/club',
      name: 'club',
      components: {
        default: () => import('@/components/club'),
        header: headerBack
      },
      meta: {
        title: '亲友圈'
      }
    },
    {
      path: '/managerReport',
      name: 'managerReport',
      components: {
        default: () => import('@/components/managerReport'),
        header: headerBack
      },
      meta: {
        title: '商务报备'
      }
    },
    {
      path: '/memberWarn',
      name: 'memberWarn',
      components: {
        default: () => import('@/components/memberWarn'),
        header: headerBack
      },
      meta: {
        title: '代理预警'
      }
    },
    {
      path: '/toggle',
      name: 'toggle',
      components: {
        default: () => import('@/components/toggle'),
        header: headerBack
      },
      meta: {
        title: '切换申请'
      }
    },
    {
      path: '/delClub',
      name: 'delClub',
      components: {
        default: () => import('@/components/delClub'),
        header: headerBack
      },
      meta: {
        title: '删亲友圈'
      }
    },
    {
      path: '/awardProgress',
      name: 'awardProgress',
      components: {
        default: () => import('@/components/awardProgress'),
        header: headerBack
      },
      meta: {
        title: '奖励进度'
      }
    },
    {
      path: '/memberApply',
      name: 'memberApply',
      components: {
        default: () => import('@/components/memberApply'),
        header: headerBack
      },
      meta: {
        title: '申请代理'
      }
    },
    {
      path: '/giftApplication',
      name: 'giftApplication',
      components: {
        default: () => import('@/components/giftApplication'),
        header: headerBack
      },
      meta: {
        title: '赠送申请'
      }
    },
    {
      path: '/merchantManagement',
      name: 'merchantManagement',
      components: {
        default: () => import('@/components/merchantManagement'),
        header: headerBack
      },
      meta: {
        title: '商户管理'
      }
    },
    {
      path: '/persentGemstone',
      name: 'persentGemstone',
      components: {
        default: () => import('@/components/merchantManagement/persentGemstone'),
        header: headerBack
      },
      meta: {
        title: '赠送宝石'
      }
    },
    {
      path: '/myAccount',
      name: 'myAccount',
      components: {
        default: () => import('@/components/myAccount'),
        header: headerBack
      },
      meta: {
        title: '我的账户'
      }
    },
    {
      path: '/withdraw',
      name: 'withdraw',
      components: {
        default: () => import('@/components/withdraw'),
        header: headerBack
      },
      meta: {
        title: '提现'
      }
    },
    {
      path: '/withdraw/withdrawRecord',
      name: 'withdrawRecord',
      components: {
        default: () => import('@/components/withdraw/recordView'),
        header: headerBack
      },
      meta: {
        title: '提现记录'
      }
    },
    {
      path: '/userInfo',
      name: 'userInfo',
      components: {
        default: () => import('@/components/userInfo')
        // header:headerBack
      },
      meta: {
        title: '我的资料'
      }
    },
    {
      path: '/userInfo/updateName',
      name: 'updateName',
      components: {
        default: () => import('@/components/userInfo/updateName'),
        header: header
      },
      meta: {
        title: '修改姓名'
      }
    },
    {
      path: '/userInfo/updateIdentityNum',
      name: 'updateIdentityNum',
      components: {
        default: () => import('@/components/userInfo/updateIdentityNum'),
        header: header
      },
      meta: {
        title: '修改身份证号'
      }
    },
    {
      path: '/userInfo/updateAliAccount',
      name: 'updateAliAccount',
      components: {
        default: () => import('@/components/userInfo/updateAliAccount'),
        header: header
      },
      meta: {
        title: '修改支付宝账号'
      }
    },
    {
      path: '/userInfo/updateCard',
      name: 'updateCard',
      components: {
        default: () => import('@/components/userInfo/updateCard'),
        header: header
      },
      meta: {
        title: '修改银行卡'
      }
    },
    {
      path: '/login',
      nama: 'login',
      components: {
        default: () => import('@/components/login'),
        header: headloginHeader
      },
      meta: {
        title: '登录'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js